export const linkStyle = {
  textDecoration: 'none',
  color: 'text.primary',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const ellipsisStyle = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};
